// A member acting on the network posts a post was published as: who it goes out from, the comments,
// likes and reposts sent on it, and the comments on it.
class SocialPostActions {

  constructor(basePath, apiClient) {

    this.apiClient = apiClient;
    this.basePath = basePath;

  }

  async setPostSocialSender(postId, provider, accountId) {

    const path = this.basePath + '/posts/:postId/social-senders/:provider';

    return this.apiClient.put(path, { postId, provider }, {}, { accountId });

  }

  async performSocialPostAction(postId, provider, data) {

    const path = this.basePath + '/posts/:postId/social-actions/:provider';

    return this.apiClient.post(path, { postId, provider }, {}, data);

  }

  async getSocialPostReactions(postId, provider) {

    const path = this.basePath + '/posts/:postId/social-reactions/:provider';

    return this.apiClient.get(path, { postId, provider }, {});

  }

  // The post's newest comments arrive as SOCIAL_POST_COMMENTS_LISTED under the request id answered.
  async listSocialPostComments(postId, provider) {

    const path = this.basePath + '/posts/:postId/social-comments/:provider';

    return this.apiClient.get(path, { postId, provider }, {});

  }

  async getSocialPostActionModes() {

    return this.apiClient.get(this.basePath + '/social-post-actions/modes', {}, {});

  }

  async getSocialPostCommentSuggestions(postId, provider, senderAccountId) {

    const path = this.basePath + '/posts/:postId/social-comment-suggestions/:provider/:senderAccountId';

    return this.apiClient.get(path, { postId, provider, senderAccountId }, {});

  }

  async regenerateSocialPostCommentSuggestions(postId, provider, senderAccountId) {

    const path = this.basePath + '/posts/:postId/social-comment-suggestions/:provider/:senderAccountId';

    return this.apiClient.post(path, { postId, provider, senderAccountId }, {}, {});

  }

}

export default SocialPostActions;
